import { usePagination, useQueryParams } from '@/hooks';
import { useEffect } from 'react';

const useRequestsPagination = () => {
  const { setQueryParams, getQueryParam } = useQueryParams();
  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    usePagination({
      initialPage: Number(getQueryParam('page')) || 1,
      initialPageSize: Number(getQueryParam('pageSize')) || 10,
    });

  useEffect(() => {
    setQueryParams({
      page: currentPage.toString(),
      pageSize: pageSize.toString(),
    });
  }, [currentPage, pageSize]);

  return {
    currentPage,
    pageSize,
    handlePageChange,
    handlePageSizeChange,
  };
};

export default useRequestsPagination;
